export function getToken(): string {
  return localStorage.getItem('referrals-auth') || '';
}

export function setToken(token: string): void {
  localStorage.setItem('referrals-auth', token);
}

export function deleteToken(): void {
  localStorage.removeItem('referrals-auth');
}
